/* eslint-disable react/prop-types */
import { Box, Container } from "@mui/material";
import React, { Fragment } from "react";
import CustomerHeader from "../common/header/CustomerHeader";
import CustomerSidebar from "../common/sidebar/CustomerSidebar";
import './CustomerConatiner.scss'
import worldMap from "../../../resources/world.png"
import OrderAssistant from "../assistant/OrderAssistant";

const CustomerConatiner = ({ loginUser, logoutUser, children, jobSearch, setJobSearch, mapDisplay, setMapDisplay, onHandleOpenCustomerNotification, chatCount, chatOpenFunction, setChatOpenOrder }) => {
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return <Fragment>
        <section className="customer-container">
            {!isMobile() && <CustomerSidebar />}
            <Box className="customer-content" style={{ height: "100vh" }}>
                <CustomerHeader setChatOpenOrder={setChatOpenOrder} chatOpenFunction={chatOpenFunction} chatCount={chatCount} onHandleOpenCustomerNotification={onHandleOpenCustomerNotification} loginUser={loginUser.fullName} logoutUser={logoutUser} jobSearch={jobSearch} setJobSearch={setJobSearch} mapDisplay={mapDisplay} setMapDisplay={setMapDisplay} />
                <Container maxWidth={false} style={{padding: 0}}>
                    {children}
                </Container>
            </Box>
            {/*<OrderAssistant />*/}
        </section>
    </Fragment>;
}

export default CustomerConatiner;